import { BookingStage, createBookingRoute } from '@/components/booking/elements/Detail.vue'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const locationStore = useLocationStore()
  const bookingStore = useBookingStore()

  await locationStore.getServices()

  const service = locationStore.getServiceById(to.params.id)

  if (!service) {
    return navigateTo('/')
  } else {
    await bookingStore.clear()
    await bookingStore.setServiceSelected({ service: service, selected: true })

    const bookingUrlQuery = bookingStore.urlQuery
    const pushRoute = createBookingRoute(bookingUrlQuery, BookingStage.AVAILABILITY)

    return navigateTo(pushRoute)
  }
})